import { IPlayerData } from 'src/interfaces/PlayerData';
import { IPlayerParams } from 'src/interfaces/PlayerParams';
import videojs from 'video.js';
import 'videojs-errors';
import { IVideoJSPlayer } from 'src/interfaces/VideoJS';
import { muxEmit } from 'src/utils/analyticsUtils';
import LiveService from 'src/services/LiveService';
import { IApplicationData } from 'src/interfaces/ApplicationData';
import { TRANSMISSION_TYPE } from 'src/interfaces/enums';
import MarkerService from '../MarkerService';
import ProgressService from '../ProgressService';
import DatahubService from '../DatahubService';
import MessageEventService from '../MessageEventService';
import PlayerConfigService from '../PlayerConfigService';
import PlayerService from '../PlayerService';
import UserPreferencesService from '../UserPreferencesService';

class ApplicationService {
  public applicationData: Readonly<IApplicationData>;

  public progress: ProgressService;
  public datahub: DatahubService;
  public messageEvent: MessageEventService;
  public userPreferences: UserPreferencesService;

  public marker: MarkerService;
  public player?: PlayerService;

  init(playerData: IPlayerData, params: IPlayerParams, applicationData: IApplicationData) {
    this.messageEvent = new MessageEventService();
    this.applicationData = applicationData as IApplicationData;

    this.userPreferences = new UserPreferencesService(applicationData);
    this.progress = new ProgressService(applicationData);

    this.marker = new MarkerService(playerData, params);
  }

  get isDRMEnabled() {
    return this.applicationData.isDrmEnabled;
  }

  async setPlayer(player: HTMLVideoElement, callback?: () => void) {
    const { applicationData } = this;
    const config = await PlayerConfigService.parsePlayerData(applicationData);

    const playerInstance = videojs(player, config, callback) as IVideoJSPlayer;

    playerInstance.errors();

    playerInstance.errors.timeout(-1);

    window.PLAYER = playerInstance;

    this.player =
      applicationData.transmissionType === TRANSMISSION_TYPE.live
        ? new LiveService(playerInstance)
        : new PlayerService(playerInstance);

    this.datahub = new DatahubService(this.applicationData, this.player.viewId);

    if (this.isDRMEnabled) await this.player?.enableDRM();
    muxEmit(playerInstance);
  }

  clean() {
    this.player?.clean();
    this.player = undefined;
  }
}

export default new ApplicationService();
